export const newsletterRoutes = [
  {
    path: "/app/newsletters",
    redirect: "/app/newsletters/email",
  },
  {
    path: "/app/newsletters/email",
    name: "PageEmailNewsletters",
    component: () => import("vue-app/pages/PageEmailNewsletters/PageEmailNewsletters.vue"),
    meta: {
      routeName: window.$_t("Newsletter"),
      noPadding: true,
      skipGlobalLoader: true,
    },
  },
  {
    path: "/app/newsletters/email/tutorial",
    name: "PageEmailNewsletterTutorial",
    component: () => import("vue-app/pages/PageEmailNewsletterTutorial/PageEmailNewsletterTutorial.vue"),
    meta: {
      routeName: "Newsletter Tutorial",
      noPadding: true,
      skipGlobalLoader: true,
    },
  },
  {
    path: "/app/newsletters/sms",
    name: "PageSmsNewsletters",
    component: () => import("vue-app/pages/PageSmsNewsletters/PageSmsNewsletters.vue"),
    meta: {
      routeName: window.$_t("SMS Newsletter"),
      skipGlobalLoader: true,
      noPadding: true,
    },
  },
  {
    path: "/app/newsletters/whatsapp",
    name: "PageWhatsappNewsletters",
    component: () => import("vue-app/pages/PageWhatsappNewsletters/PageWhatsappNewsletters.vue"),
    meta: {
      routeName: window.$_t("WhatsApp Newsletter"),
      skipGlobalLoader: true,
      noPadding: true,
    },
  },
  {
    path: "/app/demo/newsletter-hub/ai-agent",
    name: "PageNewsletterHubAIAgent",
    component: () => import("../pages/PageNewsletterHubAIAgent/PageNewsletterHubAIAgent.vue"),
    meta: {
      routeName: "AI Agent Newsletter",
      skipGlobalLoader: true,
      noPadding: true,
    },
  },
  {
    path: "/app/newsletter-hub/ai-campaign-templates/:id?",
    name: "PageNewsletterAiCampaignTemplates",
    component: () => import("../pages/PageNewsletterAiCampaignTemplates/PageNewsletterAiCampaignTemplates.vue"),
    meta: {
      routeName: "AI Campaign Templates",
      skipGlobalLoader: true,
      noPadding: true,
    },
  },
  {
    path: "/app/newsletters/email/templates-editor",
    name: "PageNewsletterHubTemplatesEditor",
    component: () => import("vue-app/pages/PageNewsletterHubTemplatesEditor.vue"),
    isDev: true,
    meta: {
      routeName: window.$_t("Editor"),
      noPadding: true,
      skipGlobalLoader: true,
    },
  },
  {
    path: "/app/newsletters/sms/:id",
    name: "PageSmsNewsletter",
    component: () => import("vue-app/pages/PageSmsNewsletter/PageSmsNewsletter.vue"),
    meta: {
      routeName: window.$_t("Editor"),
      noPadding: true,
      skipGlobalLoader: true,
    },
  },
  {
    path: "/app/newsletters/whatsapp/:id",
    name: "PageWhatsappNewsletter",
    component: () => import("vue-app/pages/PageWhatsappNewsletter/PageWhatsappNewsletter.vue"),
    meta: {
      routeName: window.$_t("Editor"),
      noPadding: true,
      skipGlobalLoader: true,
    },
  },
  {
    path: "/app/newsletters/coupons",
    component: () => import("vue-app/pages/PageCoupons/PageCoupons.vue"),
    meta: {
      routeName: window.$_t("Newsletter"),
      noPadding: true,
      backgroundColor: "#ffffff",
      skipGlobalLoader: true,
    },
  },
  {
    path: "/app/newsletters/email/templates",
    name: "PageNewsletterEmailTemplates",
    component: () => import("vue-app/pages/PageNewsletterEmailTemplates/PageNewsletterEmailTemplates.vue"),
    meta: {
      routeName: "Newsletter Templates",
      skipGlobalLoader: true,
      noPadding: true,
    },
  },
  {
    path: "/app/newsletters/email/select-product",
    name: "PageNewsletterEmailSelectProducts",
    component: () =>
      import("../vue-app-new/pages/PageNewsletterEmailSelectProducts/PageNewsletterEmailSelectProducts.vue"),
    meta: {
      routeName: "Select Products",
      skipGlobalLoader: true,
      noPadding: true,
    },
  },
  {
    path: "/app/newsletters/email/:id",
    name: "PageEmailNewsletter",
    component: () => import("vue-app/pages/PageEmailNewsletter/PageEmailNewsletter.vue"),
    redirect: (to) => `/app/newsletters/email/${to.params.id}/summary`,
    children: [
      {
        path: "design",
        name: "PageEmailNewsletterDesign",
        component: () => import("vue-app/components/NewsletterEmail/NewsletterEmailDesign.vue"),
        meta: {
          routeName: "Newsletter Editor",
          noPadding: true,
          skipGlobalLoader: true,
        },
      },
      {
        path: "ai-design",
        name: "PageNewsletterEmailAIDesign",
        component: () =>
          import(
            "vue-app/vue-app-new/modules/NewsletterEmail/features/NewsletterEmailAIDesign/NewsletterEmailAIDesign.vue"
          ),
        meta: {
          routeName: "AI Newsletter Editor",
          noPadding: true,
          skipGlobalLoader: true,
        },
      },
      {
        path: "summary",
        name: "PageEmailNewsletterSummary",
        component: () => import("vue-app/components/NewsletterEmail/NewsletterEmailSummary.vue"),
        meta: {
          routeName: "Newsletter Editor",
          noPadding: true,
          skipGlobalLoader: true,
        },
      },
    ],
  },
  {
    path: "/app/newsletters/whatsapp/templates",
    name: "PageNewsletterWhatsappTemplates",
    component: () => import("vue-app/pages/PageNewsletterWhatsappTemplates/PageNewsletterWhatsappTemplates.vue"),
    meta: {
      routeName: "Newsletter Templates",
      skipGlobalLoader: true,
      noPadding: true,
    },
  },
  {
    path: "/app/newsletters/sms/templates",
    name: "PageNewsletterSmsTemplates",
    component: () => import("vue-app/pages/PageNewsletterSmsTemplates/PageNewsletterSmsTemplates.vue"),
    meta: {
      routeName: "Newsletter Templates",
      skipGlobalLoader: true,
      noPadding: true,
    },
  },
];
